var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seemore"},_vm._l((_vm.seemoreData),function(item,index){return _c('div',{key:index,staticClass:"seemore-item",on:{"click":function($event){return _vm.gotoNextPath(item.path)}}},[_vm._v(" "+_vm._s(item.name)+" "),_c('i',{staticClass:"icon icon-bor-arrow-right text-red-400 ml-1 inline-block"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }